<template>
    <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 10L14.5 14L19 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
</template>
